import React, { Component, Fragment } from "react";
import { Helmet } from "react-helmet";
import numeral from "numeral";

import GraphTemp from "../../components/page/analytics/Graph/GraphTemp";
import { boxiGreen, boxiPrimary } from "../../assets/style/colors";
import truckIcon from "../../assets/icons/truck.png";
import roadIcon from "../../assets/icons/road.png";
import peopleIcon from "../../assets/icons/people.png";
import { connect } from "react-redux";
import classes from './ClientMapTheme.module.scss'

class AnalyticsPageTemp extends Component {
  constructor(props){
   super(props)
   this.state = {
      isClientAnalytics: false
   } 
  }

  componentDidMount(){
    if(this.props?.match?.params?.client_id){
      this.setState({
        isClientAnalytics: !!this.props?.match?.params?.client_id
      })
    }
  }
  
  render() {
    return (
      <Fragment>
        <Helmet>
          <title>Boxi | Analytics</title>
        </Helmet>
        {/* <DataOverviewTemp /> */}
        <div style={this.state.isClientAnalytics ? {marginLeft: '300px' ,width: '75%'} : {}}>
        <div className={classes.analytics_card_count_container}>
          <div className={classes.analytics_card_count_card}>
            <div className={classes.analytics_card_count_card_image} style={{ 
              background: '#B93A76',
              border: '1px solid #B93A76'
             }}>
              <img src={truckIcon} alt="truckIcon" />
            </div>
            <p className={
              classes.analytics_card_count_card_text
            }>Total Trucks</p>
            <span className={classes.analytics_card_count_card_number}>{numeral(this.props.vehicleCount).format("0,0")}</span>
          </div>
          <div className={classes.analytics_card_count_card}>
            <div className={classes.analytics_card_count_card_image} style={{
                background: '#DD314F',
                border: '1px solid' + '#DD314F',
            }}>
              <img src={roadIcon} alt="roadIcon" />
            </div>
            <p className={classes.analytics_card_count_card_text}>Total Miles Driven</p>
            <span className={
              classes.analytics_card_count_card_number
            }>{numeral(this.props.totalMilesDriven).format("0,0")}</span>
          </div>
          <div className={classes.analytics_card_count_card}>
            <div className={classes.analytics_card_count_card_image} style={{
             background: '#F6503C',
              border: '1px solid' + '#F6503C'
            }}>
              <img src={peopleIcon} alt="peopleIcon" />
            </div>
            <p className={classes.analytics_card_count_card_text}>Total Impressions</p>
            <span className={classes.analytics_card_count_card_number}>{numeral(this.props.totalImpressions).format("0,0")}</span>
          </div>


        </div>
        <GraphTemp />
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    vehicleCount: state.clientDashboardTemp.analytics.vehicleCount,
    totalMilesDriven: state.clientDashboardTemp.analytics.totalMilesDriven,
    totalImpressions: state.clientDashboardTemp.analytics.totalImpressions
  };
};

export default connect(mapStateToProps)(AnalyticsPageTemp);
